import React, { useState, useEffect } from "react";
import { FaTimes, FaSave } from "react-icons/fa";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function CrearTipoEstado({
  onClose = () => {},
  onCreated = () => {},
}) {
  const [nombre, setNombre] = useState("");
  const [saving, setSaving] = useState(false);

  // Form válido como en CrearUsuarios.jsx
  const isValid = nombre.trim() !== "";

  // Cerrar con ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const guardar = async () => {
    if (!isValid || saving) return;

    const payload = {
      nombre: nombre.trim(),
    };

    try {
      setSaving(true);

      const nuevo = await appFetchJson(
        apiRoutes.estadoTipo.create,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      onCreated(nuevo);
      onClose();
    } catch (e) {
      console.error(e);
      alert("Error al crear Tipo de Estado");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-md" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Crear Tipo de Estado</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <div className="form-grid">
            <div className="form-row">
              <label className="form-label">Nombre *</label>
              <input
                type="text"
                className="input"
                placeholder="Ej: ACTIVO, INACTIVO, BLOQUEADO"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <div className="btn-row">
            {/* Botón Guardar con validación FLPA */}
            <button
              type="button"
              className={`btn-fil btn-wide ${
                !isValid || saving ? "opacity-60 cursor-not-allowed" : ""
              }`}
              disabled={!isValid || saving}
              onClick={guardar}
              title={
                !isValid
                  ? "Complete todos los campos obligatorios"
                  : saving
                    ? "Guardando..."
                    : "Guardar"
              }
            >
              <FaSave className="inline mr-2" />
              {saving ? "Guardando…" : "Guardar"}
            </button>

            <button type="button" className="btn-fil" onClick={onClose}>
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
